<template>
    <div class="form-box">
        <el-form :model="form">
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-form-item label="商户号:">
                        <el-input v-model="form.no" placeholder="" />
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="商户名称:">
                        <el-input v-model="form.merchant_name" placeholder="" />
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="联系人:">
                        <el-input v-model="form.contact_person_name" placeholder="" />
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="手机号:">
                        <el-input v-model="form.contact_person_phone" placeholder="" />
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="代理商:">
                        <el-select v-model="form.agent_id" filterable clearable>
                            <el-option v-for="(agent, index) in agents" :key="index" :label="agent.company"
                                :value="agent.id" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="业务员:">
                        <el-select v-model="form.salesman_id" filterable clearable>
                            <el-option v-for="(salesman, index) in salesmanList" :key="index" :label="salesman.name"
                                :value="salesman.id" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item>
                        <el-button type="primary" id="search" @click="search">
                            <el-icon>
                                <Search />
                            </el-icon>
                            搜索
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
    <div class="table-box">
        <div class="table-head">
            <span class="table-title">商户列表</span>
            <span style="margin-left:15px">
                <el-link v-if="!showMultiChangeSelection" type="primary" @click="showSelection(true)">批量操作</el-link>
                <el-link v-if="showMultiChangeSelection" type="primary" @click="showSelection(false)">取消批量操作</el-link>
                <el-link v-if="showMultiChangeSelection" type="primary" style="margin-left:10px"
                    @click="showMerchantChangeBox">转移商户</el-link>
            </span>
            <span class="table-title" style="float:right;display:flex;flex-direction:row;font-size:16px;line-height:32px">
                <span>上传轻收单:</span>
                <span style="margin-left:10px"><el-input v-model="merNo" /></span>
                <span style="margin-left:10px"><el-button type="primary" @click="uploadOrder">上传</el-button></span>
            </span>
        </div>
        <div class="table-main">
            <c-table ref="table" :tableDataUrl="tableDataUrl" :border="true" :defaultSort="defaultSort" :isLoadData="true"
                @selectionRows="testSelect">
                <template v-if="showMultiChangeSelection">
                    <el-table-column type="selection"></el-table-column>
                </template>
                <el-table-column type="index" width="55" label="序号" :align="'center'" />
                <el-table-column prop="no" label="商户号" />
                <el-table-column prop="merchant_name" label="商户名称" />
                <el-table-column prop="merchant_alias" label="商户简称" />
                <el-table-column label="联系人信息">
                    <template #default="scope">
                        <span>{{ scope.row.contact_person_name }} - {{ scope.row.contact_person_phone }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="商户类型">
                    <template #default="scope">
                        <span v-if="scope.row.business_type == 0">企业</span>
                        <span v-if="scope.row.business_type == 1">个体工商户</span>
                        <span v-if="scope.row.business_type == 2">小微商户</span>
                    </template>
                </el-table-column>
                <el-table-column label="一级代理商">
                    <template #default="scope">
                        {{ scope.row.agent.first_agent_name }}
                    </template>
                </el-table-column>
                <el-table-column label="二级代理商">
                    <template #default="scope">
                        {{ scope.row.agent.second_agent_name }}
                    </template>
                </el-table-column>
                <el-table-column label="三级代理商">
                    <template #default="scope">
                        {{ scope.row.agent.three_agent_name }}
                    </template>
                </el-table-column>
                <el-table-column label="业务员">
                    <template #default="scope">
                        {{ scope.row.salesman.name }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间">
                    <template #default="scope">
                        {{ format(scope.row.created_at) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" #default="scope">
                    <span class="operate operate-icon">
                        <el-button type="primary" @click="edit(scope.row)">
                            <el-icon :size="20">
                                <Edit />
                            </el-icon>
                        </el-button>
                    </span>

                    <span class="operate operate-dropdown">
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                ...
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item @click="merchantChannel(scope.row)">商户通道</el-dropdown-item>
                                    <el-dropdown-item @click="merchantStore(scope.row)">门店管理</el-dropdown-item>
                                    <el-dropdown-item @click="merchantCashier(scope.row)">收银员管理</el-dropdown-item>
                                    <el-dropdown-item @click="merchantDevice(scope.row)">设备管理</el-dropdown-item>
                                    <el-dropdown-item @click="merchantActivity(scope.row)">活动管理</el-dropdown-item>
                                    <el-dropdown-item @click="showMerchantChangeBox(scope.row)">商户转移</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </span>
                </el-table-column>
            </c-table>
        </div>
    </div>
    <el-dialog v-model="isShowChangeBox">
        <template #header>
            商户迁移
        </template>
        <el-form :model="changeForm" label-width="120px">
            <el-form-item label="代理商：">
                <el-select v-model="changeForm.agent_id" filterable clearable @change="selectorSalesman">
                    <el-option v-for="(agent, index) in agents" :key="index" :label="agent.company" :value="agent.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="业务员：">
                <el-select v-model="changeForm.salesman_id" filterable clearable>
                    <el-option v-for="(salesman, index) in agentLevelSalesmanList" :key="index" :label="salesman.name"
                        :value="salesman.id" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="merchantChange">确定</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <merchant-channel ref="merchant_channel"></merchant-channel>
    <merchant-store ref="merchant_store"></merchant-store>
    <cashier ref="merchant_cashier"></cashier>
    <device ref="merchant_device"></device>
    <activity ref="merchant_activity"></activity>
</template>

<script>
import cTable from '@/components/CustomTable'
import { timeFormat } from '@/func/time'
import { Search, Edit } from '@element-plus/icons-vue'
import storeTools from '@/tools/storeTools'
import merchantChannel from './channel'
import merchantStore from './store'
import cashier from './cashier'
import device from './device'
import activity from './activity'
import { ElMessage } from 'element-plus'


export default {
    components: {
        cTable,
        Search,
        Edit,
        merchantChannel,
        merchantStore,
        cashier,
        device,
        activity
    },
    mounted() {
        this.loadAgents()
        this.loadSalesmanList()
    },
    data() {
        return {
            defaultSort: {
                prop: 'sort', order: 'descending'
            },
            tableDataUrl: this.$api.merchant.list,
            form: {},
            changeForm: {},
            merNo: '',
            agents: null,
            salesmanList: null,
            isShowChangeBox: false,
            agentLevelSalesmanList: [],
            merchant: null,
            showMultiChangeSelection: false,
            merchantIds: []
        }
    },
    methods: {
        search() {
            this.$nextTick(() => {
                this.$refs.table.search(this.form)
            })

        },
        format(date) {
            return timeFormat(date)
        },

        edit(merchantInfo) {
            storeTools.setTabs('新增商户', 'merchant_new', '/merchant/new')
            this.$router.push({ path: '/merchant/new', query: { id: merchantInfo.id } })
        },
        merchantChannel(merchantInfo) {
            this.$nextTick(() => {
                this.$refs.merchant_channel.open(merchantInfo)
            })

        },
        merchantStore(merchantInfo) {
            this.$nextTick(() => {
                this.$refs.merchant_store.open(merchantInfo)
            })
        },
        merchantCashier(merchantInfo) {
            this.$nextTick(() => {
                this.$refs.merchant_cashier.open(merchantInfo)
            })
        },
        merchantDevice(merchantInfo) {
            this.$nextTick(() => {
                this.$refs.merchant_device.open(merchantInfo)
            })
        },
        merchantActivity(merchantInfo) {
            this.$nextTick(() => {
                this.$refs.merchant_activity.open(merchantInfo)
            })
        },
        showMerchantChangeBox(merchantInfo) {
            this.isShowChangeBox = true
            this.merchant = merchantInfo
        },
        selectorSalesman(val) {
            const params = {
                agent_id: val
            }
            this.$api.salesman.levelAgentSalesman(params).then(r => {
                this.agentLevelSalesmanList = r.data
            })
        },
        merchantChange() {
            if (!this.changeForm.agent_id || !this.changeForm.salesman_id) {
                ElMessage({ message: '参数有误', type: 'error' })
                return
            }
            if (this.merchant.id) {
                this.merchantIds = [this.merchant.id]
            }
            const params = {
                merchant_id: this.merchantIds,
                agent_id: this.changeForm.agent_id,
                salesman_id: this.changeForm.salesman_id
            }

            this.$api.merchant.merchantChange(params).then(r => {
                if (r.status == 200) {
                    ElMessage({ message: '修改成功', type: 'success' })
                    this.isShowChangeBox = false
                }
            })
        },
        uploadOrder() {
            console.log(this.merNo)
        },
        loadAgents() {
            this.$api.agent.levelAgents.list().then(r => {
                this.agents = r.data
            })
        },
        loadSalesmanList() {
            this.$api.salesman.levelAgentSalesman().then(r => {
                this.salesmanList = r.data
            })
        },
        showSelection(isShow) {
            this.showMultiChangeSelection = isShow
        },
        testSelect(rows) {
            this.merchantIds = []

            for (var i = 0; i < rows.length; i++) {
                this.merchantIds.push(rows[i].id)
            }
        }
    }
}
</script>

<style lang="less" scoped>
.operate {
    color: #409EFF;
    cursor: pointer;
    margin-left: 10px;
}
</style>